import {http_client} from "../plugins/http_client";

const getConsolidado = async (tipo, queryParams) => await http_client(`/api/v1/planilla/reporte-planilla/resumen/${tipo}`, queryParams, 'get')
const getPDF = async (queryParams) => await http_client(`/api/v1/reporte-planilla/resumen-planilla-pdf`, queryParams, 'get', {}, true)

// Funciones para obtener los filtros
const obtenerCifradoPresupuestoPlanilla = async (queryParams) => await http_client('/api/v1/planilla/reporte-planilla/resumen/filtros/cifrado', queryParams, 'get')
const obtenerUnidadesPresupuestariasPlanilla = async (queryParams) => await http_client('/api/v1/planilla/reporte-planilla/resumen/filtros/unidad-presupuestaria', queryParams, 'get')
const obtenerLineasTrabajoPlanilla = async (queryParams) => await http_client('/api/v1/planilla/reporte-planilla/resumen/filtros/linea-trabajo', queryParams, 'get')
const obtenerSistemasPagoPlanilla = async (queryParams) => await http_client('/api/v1/planilla/reporte-planilla/resumen/filtros/sistema-pago', queryParams, 'get')
const obtenerFuentesFinanciamientoPlanilla = async (queryParams) => await http_client('/api/v1/planilla/reporte-planilla/resumen/filtros/fuente-financiamiento', queryParams, 'get')
const obtenerFuentesRecursoPlanilla = async (queryParams) => await http_client('/api/v1/planilla/reporte-planilla/resumen/filtros/fuente-recurso', queryParams, 'get')

export default {
  getConsolidado,
  getPDF,
  obtenerCifradoPresupuestoPlanilla,
  obtenerUnidadesPresupuestariasPlanilla,
  obtenerLineasTrabajoPlanilla,
  obtenerSistemasPagoPlanilla,
  obtenerFuentesFinanciamientoPlanilla,
  obtenerFuentesRecursoPlanilla,
}